export enum SimpleInformationProjectEnum {
  RSEE_PROJECT = "RSEE_PROJECT",
  BS_PROJECT = "BS_PROJECT",
  PROJECT = "PROJECT",
}
